export default __webpack_public_path__ + "static/media/3.d78c75bf.jpg";